import { useLocation } from 'react-router-dom';

/**
 * usePathname hook
 * Get current pathname from React Router
 */
export default function usePathname() {
	const location = useLocation();
	return location.pathname;
}
